import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=23da51d9&scoped=true"
import script from "./DropdownDivider.vue?vue&type=script&lang=js"
export * from "./DropdownDivider.vue?vue&type=script&lang=js"
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&id=23da51d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da51d9",
  null
  
)

export default component.exports